var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserFill = function SvgUserFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#62687A",
    d: "M7 6.979q-1.375 0-2.25-.875t-.875-2.25.875-2.25T7 .729q1.376 0 2.25.875t.875 2.25-.875 2.25q-.874.875-2.25.875m-5.417 6.687q-.52 0-.885-.364a1.2 1.2 0 0 1-.365-.886v-.708q0-.792.396-1.354T1.75 9.5q1.397-.626 2.678-.938A10.8 10.8 0 0 1 7 8.25q1.292 0 2.562.323a18 18 0 0 1 2.667.927q.646.291 1.042.854t.396 1.354v.708q0 .522-.365.886a1.2 1.2 0 0 1-.885.364z"
  })));
};
export default SvgUserFill;